import { lazy } from 'react';

import { ModalNamesEnum } from '../enums/modalNames.enum';

import { componentLoader } from './componentLoader';

const PhotoCropModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/media/PhotoCropModal/PhotoCropModal')),
);

const BaseConfirmModal = lazy(() =>
  componentLoader(
    () => import('../../compositeComponents/modals/confirmModals/BaseConfirmModal/BaseConfirmModal'),
  ),
);
const PurchaseModal = lazy(() =>
  componentLoader(
    () => import('../../compositeComponents/modals/organizer/purchase/PurchaseModal/PurchaseModal'),
  ),
);
const PlanDetailsModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/settings/plan/PlanDetailsModal')),
);
const ConfirmWithTwoVariantModal = lazy(() =>
  componentLoader(
    () =>
      import(
        '../../compositeComponents/modals/confirmModals/ConfirmWithTwoVariantModal/ConfirmWithTwoVariantModal'
      ),
  ),
);
const ConfirmModalWithThreeVariant = lazy(() =>
  componentLoader(
    () =>
      import(
        '../../compositeComponents/modals/confirmModals/ConfirmModalWithThreeVariant/ConfirmModalWithThreeVariant'
      ),
  ),
);
const ConfirmModalWithPassword = lazy(() =>
  componentLoader(
    () =>
      import(
        '../../compositeComponents/modals/confirmModals/ConfirmModalWithPassword/ConfirmModalWithPassword'
      ),
  ),
);
const ConfirmModalWithInput = lazy(() =>
  componentLoader(
    () => import('@compositeComponents/modals/confirmModals/ConfirmModalWithInput/ConfirmModalWithInput'),
  ),
);
const ConfirmModalWithSelect = lazy(() =>
  componentLoader(
    () =>
      import('../../compositeComponents/modals/confirmModals/ConfirmModalWithSelect/ConfirmModalWithSelect'),
  ),
);

const ConfirmDeclineModal = lazy(() =>
  componentLoader(
    () => import('../../compositeComponents/modals/confirmModals/ConfirmDeclineModal/ConfirmDeclineModal'),
  ),
);
const UserFullNameModal = lazy(() =>
  componentLoader(
    () => import('../../compositeComponents/modals/routing/UserFullNameModal/UserFullNameModal'),
  ),
);

const TermsModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/auth/signUp/terms/TermsModal/TermsModal')),
);
const PolicyModal = lazy(() =>
  componentLoader(
    () => import('../../compositeComponents/modals/auth/signUp/policy/PolicyModal/PolicyModal'),
  ),
);

const ProfileAppearanceModal = lazy(() =>
  componentLoader(
    () =>
      import('../../compositeComponents/modals/hubs/profile/ProfileAppearanceModal/ProfileAppearanceModal'),
  ),
);
const BodyArtsModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/hubs/profile/BodyArtsModal')),
);
const ProfileContactsModal = lazy(() =>
  componentLoader(
    () => import('../../compositeComponents/modals/hubs/profile/ProfileContactsModal/ProfileContactsModal'),
  ),
);
const RoadmapFiltersModal = lazy(() =>
  componentLoader(
    () =>
      import('../../compositeComponents/modals/organizer/roadmap/RoadmapFiltersModal/RoadmapFiltersModal'),
  ),
);
const NetworkFiltersModal = lazy(() =>
  componentLoader(
    () => import('../../compositeComponents/modals/network/NetworkFiltersModal/NetworkFiltersModal'),
  ),
);

const ArchiveFiltersModal = lazy(() =>
  componentLoader(
    () => import('../../compositeComponents/modals/settings/archive/ArchiveFiltersModal/ArchiveFiltersModal'),
  ),
);
const ArchiveSettingsModal = lazy(() =>
  componentLoader(
    () =>
      import('../../compositeComponents/modals/settings/archive/ArchiveSettingsModal/ArchiveSettingsModal'),
  ),
);
const CalendarFilterModal = lazy(() =>
  componentLoader(
    () =>
      import('../../compositeComponents/modals/organizer/calendar/CalendarFilterModal/CalendarFilterModal'),
  ),
);
const PlannerFiltersModal = lazy(() =>
  componentLoader(
    () =>
      import('../../compositeComponents/modals/organizer/planner/PlannerFiltersModal/PlannerFiltersModal'),
  ),
);
const CreateTaskModal = lazy(() =>
  componentLoader(
    () => import('../../compositeComponents/modals/organizer/tasks/CreateTaskModal/CreateTaskModal'),
  ),
);

const ViewTaskModal = lazy(() =>
  componentLoader(
    () => import('../../compositeComponents/modals/organizer/tasks/ViewTaskModal/ViewTaskModal'),
  ),
);

const CreateEventModal = lazy(() =>
  componentLoader(
    () => import('../../compositeComponents/modals/organizer/events/CreateEventModal/CreateEventModal'),
  ),
);
const ViewEventModal = lazy(() =>
  componentLoader(
    () => import('../../compositeComponents/modals/organizer/events/ViewEventModal/ViewEventModal'),
  ),
);
const ReplyModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/chat/ReplyModal/ReplyModal')),
);
const GroupModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/chat/GroupModal/GroupModal')),
);
const VehicleStickerModal = lazy(() =>
  componentLoader(
    () => import('../../compositeComponents/modals/hubs/garage/document-modals/VehicleSticker'),
  ),
);

const CreateContactModal = lazy(() =>
  componentLoader(
    () => import('../../compositeComponents/modals/network/CreateContactModal/CreateContactModal'),
  ),
);

const CreateContactShortModal = lazy(() =>
  componentLoader(
    () => import('../../compositeComponents/modals/network/CreateContactShortModal/CreateContactShortModal'),
  ),
);

const CreateCompanyContactModal = lazy(() =>
  componentLoader(
    () =>
      import('../../compositeComponents/modals/network/CreateCompanyContactModal/CreateCompanyContactModal'),
  ),
);

const LicencePlateStickerModal = lazy(() =>
  componentLoader(
    () => import('../../compositeComponents/modals/hubs/garage/document-modals/LicencePlateSticker'),
  ),
);

const PaymentModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/settings/plan/payment')),
);
const DowngradePlanModal = lazy(() =>
  componentLoader(
    () => import('../../compositeComponents/modals/settings/plan/DowngradePlanModal/DowngradePlanModal'),
  ),
);
const DowngradePlanModalNew = lazy(() =>
  componentLoader(
    () =>
      import('../../compositeComponents/modals/settings/plan/DowngradePlanModalNew/DowngradePlanModalNew'),
  ),
);

const ShareModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/hubs/share/ShareModal/ShareModal')),
);
const PlanUpgradeModal = lazy(() =>
  componentLoader(
    () => import('../../compositeComponents/modals/settings/plan/PlanUpgradeModal/PlanUpgradeModal'),
  ),
);
const PlanAddCardModal = lazy(() =>
  componentLoader(
    () => import('../../compositeComponents/modals/settings/plan/PlanAddCardModal/PlanAddCardModal'),
  ),
);
const EventModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/organizer/events/EventModal')),
);
const MediaModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/media/MediaModal/MediaModal')),
);

const ChecklistTemplatesModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/todo/ChecklistTemplatesModal')),
);

const TemplatesModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/hubs/templates/TemplateModal')),
);

const WithCreateVariantsModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/todo/WithCreateVariantsModal')),
);

const TodoFiltersModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/todo/TodoFiltersModal')),
);

const AttachFilesModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/media/AttachFilesModal')),
);
const AlertModal = lazy(() => componentLoader(() => import('../../compositeComponents/modals/alertModal')));

const CreateMeetingModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/organizer/meetings/CreateMeetingModal')),
);
const CreateAppointmentModal = lazy(() =>
  componentLoader(
    () => import('../../compositeComponents/modals/organizer/appointments/CreateAppointmentModal'),
  ),
);
const CreateReminderModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/organizer/reminders/CreateReminderModal')),
);
const ViewMeetingModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/organizer/meetings/ViewMeetingModal')),
);
const ViewReminderModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/organizer/reminders/ViewReminderModal')),
);
const ViewAppointmentModal = lazy(() =>
  componentLoader(
    () => import('../../compositeComponents/modals/organizer/appointments/ViewAppointmentModal'),
  ),
);

const InvitationModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/network/InvitationModal')),
);

const EmailOrPhoneInvitationModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/network/EmailOrPhoneInvitationModal')),
);

const AddConnectionModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/network/AddConnectionModal')),
);

const EditConnectionModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/network/EditConnectionModal')),
);

const ViewTodoModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/todo/ViewTodoModal')),
);
const ViewNoteModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/todo/ViewNoteModal')),
);
const ChooseInsuranceModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/hubs/garage/ChoseInsuranceModal')),
);

const AddGarageDocumentsModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/hubs/garage/AddDocuments')),
);

const EditInsuranceModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/hubs/garage/document-modals/Insurance')),
);
const SetTimeFrameModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/organizer/tasks/SetTimeFrame')),
);
const ConvertChecklistsItemToTaskModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/todo/ConvertChecklistItemToTaskModal')),
);
const CancelSubscriptionModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/settings/plan/CancelSubscriptionModal')),
);
const LoginMethodModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/auth/login/LoginMethodModal')),
);
const PaymentHistoryFiltersModal = lazy(() =>
  componentLoader(
    () =>
      import('../../compositeComponents/modals/organizer/finance/paymentHistory/PaymentHistoryFiltersModal'),
  ),
);
const CreateTransactionModal = lazy(() =>
  componentLoader(
    () => import('@compositeComponents/modals/organizer/finance/paymentHistory/CreateTransactionModal'),
  ),
);

const ViewPaymentModal = lazy(() =>
  componentLoader(
    () => import('@compositeComponents/modals/organizer/finance/paymentHistory/ViewTransactionModal'),
  ),
);
const ConfirmWithRadioButtonsModal = lazy(() =>
  componentLoader(
    () => import('../../compositeComponents/modals/confirmModals/ConfirmWithRadioButtonsModal'),
  ),
);

const CharityCampagneParticipate = lazy(() =>
  componentLoader(
    () =>
      import(
        '../../compositeComponents/modals/PetCharityCampagne/CharityCampagneParticipant/CharityCampagneParticipant'
      ),
  ),
);

const HubFiltersModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/hubs/HubFiltersModal')),
);

const HealthInsuranceModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/hubs/profile/HealthInsuranceModal')),
);

const ConfirmModalWithTemplate = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/confirmModals/ConfirmModalWithTemplate')),
);

const CreateReminderPopup = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/hubs/CreateReminderPopup')),
);

const BillsFiltersModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/organizer/finance/bills/BillsFiltersModal')),
);

const EditBillModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/organizer/finance/bills/EditBillModal')),
);

const HelpCenter = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/setup/HelpCenterModal')),
);

const Feedback = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/setup/FeedbackModal')),
);

const SendUsAnEmail = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/setup/SendUsAnEmailModal')),
);

const PetInsuranceModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/hubs/pets/PetInsuranceModal')),
);
const PetVaccineModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/hubs/pets/PetVaccineModal')),
);

const SliderModal = lazy(() => componentLoader(() => import('../../compositeComponents/modals/sliderModal')));
const ViewWalletAccountModal = lazy(() =>
  componentLoader(
    () => import('@compositeComponents/modals/organizer/finance/wallet/ViewWalletAccountModal'),
  ),
);
const CloudUpdateName = lazy(() =>
  componentLoader(
    () => import('../../pages/organizer/Cloud/modals/CloudCreateUpdateNameModal/CloudCreateUpdateNameModal'),
  ),
);

const CloudDuplicateFile = lazy(() =>
  componentLoader(
    () => import('../../pages/organizer/Cloud/modals/CloudDuplicateFileModal/CloudDuplicateFileModal'),
  ),
);
const CloudMove = lazy(() =>
  componentLoader(() => import('../../pages/organizer/Cloud/modals/CloudMove/CloudMove')),
);

const SetupWidgets = lazy(() =>
  componentLoader(() => import('@pages/organizer/Widgets/modals/SetupWidgets/SetupWidgets')),
);
const HubSharePermissions = lazy(() =>
  componentLoader(
    () => import('../../compositeComponents/modals/hubs/share/HubSharePermissions/HubSharePermissions'),
  ),
);

const PersonalShare = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/hubs/profile/ShareModal')),
);
const ManageLinkedAccountsModal = lazy(() =>
  componentLoader(
    () => import('../../compositeComponents/modals/organizer/finance/wallet/ManageLinkedAccountsModal'),
  ),
);

const DeleteAccountUponRegistration = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/auth/registration/DeleteRegistrationModal')),
);
const WelcomeToHubmeeModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/setup/WelcomeToHubmeeModal')),
);

const InviteModal = lazy(() =>
  componentLoader(() => import('@compositeComponents/modals/InviteModal/InviteModal')),
);

const AssignedUsersListModal = lazy(() =>
  componentLoader(() => import('@compositeComponents/modals/AssignedUsersListModal')),
);

const TrialModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/auth/registration/trial-modal/TrialModal')),
);
const ScanHealthInsurance = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/hubs/profile/ScanHealthInsuranceModal')),
);
const DigitalPersonalCard = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/hubs/profile/DigitalPersonalCardModal')),
);
const DigitalBusinessCard = lazy(() =>
  componentLoader(() => import('../../pages/hubs/Work/modals/BusinessCardModal')),
);

const SpendingBreakdownDetailsModal = lazy(() =>
  componentLoader(
    () => import('../../compositeComponents/modals/organizer/finance/widgets/SpendingBreakdownDetailsModal'),
  ),
);
const QuickCreationHubModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/hubs/QuickCreationHubModal')),
);
const CalendarProviderLinkingModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/linking/CalendarProviderLinkingModal')),
);

const FeedbackSurveyModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/setup/FeedbackSurveyModal')),
);

const WalletAccountLinkingModal = lazy(() =>
  componentLoader(() => import('../../compositeComponents/modals/linking/WalletAccountLinkingModal')),
);

const ScanBusinessCard = lazy(() =>
  componentLoader(() => import('../../pages/organizer/Contacts/modals/ScanBusinessCardModal')),
);

const modalsMap: Record<ModalNamesEnum, any> = {
  [ModalNamesEnum.calendarProvidersLinking]: CalendarProviderLinkingModal,
  [ModalNamesEnum.walletAccountsLinking]: WalletAccountLinkingModal,
  [ModalNamesEnum.editBillModal]: EditBillModal,
  [ModalNamesEnum.welcomeToHubmee]: WelcomeToHubmeeModal,
  [ModalNamesEnum.manageLinkedAccountsModal]: ManageLinkedAccountsModal,
  [ModalNamesEnum.viewWalletAccountModal]: ViewWalletAccountModal,
  [ModalNamesEnum.billsFiltersModal]: BillsFiltersModal,
  [ModalNamesEnum.confirmModalWithTemplates]: ConfirmModalWithTemplate,
  [ModalNamesEnum.viewTransactionModal]: ViewPaymentModal,
  [ModalNamesEnum.createTransaction]: CreateTransactionModal,
  [ModalNamesEnum.paymentHistoryFiltersModal]: PaymentHistoryFiltersModal,
  [ModalNamesEnum.convertChecklistsItemToTask]: ConvertChecklistsItemToTaskModal,
  [ModalNamesEnum.setTimeFrame]: SetTimeFrameModal,
  [ModalNamesEnum.cancelSubscriptionModal]: CancelSubscriptionModal,
  [ModalNamesEnum.mediaViewer]: MediaModal,
  [ModalNamesEnum.choseInsurance]: ChooseInsuranceModal,
  [ModalNamesEnum.viewNoteModal]: ViewNoteModal,
  [ModalNamesEnum.viewTodoModal]: ViewTodoModal,
  [ModalNamesEnum.photoCrop]: PhotoCropModal,
  [ModalNamesEnum.baseConfirmModal]: BaseConfirmModal,
  [ModalNamesEnum.purchaseModal]: PurchaseModal,
  [ModalNamesEnum.planDetails]: PlanDetailsModal,
  [ModalNamesEnum.confirmWithTwoVariantModal]: ConfirmWithTwoVariantModal,
  [ModalNamesEnum.confirmModalWithThreeVariant]: ConfirmModalWithThreeVariant,
  [ModalNamesEnum.confirmModalWithPassword]: ConfirmModalWithPassword,
  [ModalNamesEnum.confirmModalWithInput]: ConfirmModalWithInput,
  [ModalNamesEnum.confirmModalWithSelect]: ConfirmModalWithSelect,
  [ModalNamesEnum.confirmDeclineModal]: ConfirmDeclineModal,
  [ModalNamesEnum.userFullNameModal]: UserFullNameModal,
  [ModalNamesEnum.termsModal]: TermsModal,
  [ModalNamesEnum.policyModal]: PolicyModal,
  [ModalNamesEnum.profileAppearance]: ProfileAppearanceModal,
  [ModalNamesEnum.bodyArts]: BodyArtsModal,
  [ModalNamesEnum.profileContacts]: ProfileContactsModal,
  [ModalNamesEnum.roadmapFiltersModal]: RoadmapFiltersModal,
  [ModalNamesEnum.networkFiltersModal]: NetworkFiltersModal,
  [ModalNamesEnum.archiveFiltersModal]: ArchiveFiltersModal,
  [ModalNamesEnum.archiveSettingsModal]: ArchiveSettingsModal,
  [ModalNamesEnum.calendarFiltersModal]: CalendarFilterModal,
  [ModalNamesEnum.plannerFiltersModal]: PlannerFiltersModal,
  [ModalNamesEnum.createTaskModal]: CreateTaskModal,
  [ModalNamesEnum.createMeetingModal]: CreateMeetingModal,
  [ModalNamesEnum.viewTaskModal]: ViewTaskModal,
  [ModalNamesEnum.viewMeetingModal]: ViewMeetingModal,
  [ModalNamesEnum.createEventModal]: CreateEventModal,
  [ModalNamesEnum.viewEventModal]: ViewEventModal,
  [ModalNamesEnum.replyModal]: ReplyModal,
  [ModalNamesEnum.groupChatModal]: GroupModal,
  [ModalNamesEnum.vehicleStickerModal]: VehicleStickerModal,
  [ModalNamesEnum.createContactModal]: CreateContactModal,
  [ModalNamesEnum.createContactShortModal]: CreateContactShortModal,
  [ModalNamesEnum.createCompanyContactModal]: CreateCompanyContactModal,
  [ModalNamesEnum.garageLicense]: LicencePlateStickerModal,
  [ModalNamesEnum.payment]: PaymentModal,
  [ModalNamesEnum.downgradePlan]: DowngradePlanModal,
  [ModalNamesEnum.downgradePlanNew]: DowngradePlanModalNew,
  [ModalNamesEnum.shareModal]: ShareModal,
  [ModalNamesEnum.upgradePlan]: PlanUpgradeModal,
  [ModalNamesEnum.addPlanCard]: PlanAddCardModal,
  [ModalNamesEnum.promocodeEvent]: EventModal,
  [ModalNamesEnum.checklistTemplatesModal]: ChecklistTemplatesModal,
  [ModalNamesEnum.templatesModal]: TemplatesModal,
  [ModalNamesEnum.withCreateVariantsModal]: WithCreateVariantsModal,
  [ModalNamesEnum.todoFiltersModal]: TodoFiltersModal,
  [ModalNamesEnum.attachFiles]: AttachFilesModal,
  [ModalNamesEnum.alertModal]: AlertModal,
  [ModalNamesEnum.invitationModal]: InvitationModal,
  [ModalNamesEnum.emailOrPhoneInvitationModal]: EmailOrPhoneInvitationModal,
  [ModalNamesEnum.editConnectionModal]: EditConnectionModal,
  [ModalNamesEnum.addConnectionModal]: AddConnectionModal,
  [ModalNamesEnum.createAppointmentModal]: CreateAppointmentModal,
  [ModalNamesEnum.createReminderModal]: CreateReminderModal,
  [ModalNamesEnum.viewReminderModal]: ViewReminderModal,
  [ModalNamesEnum.viewAppointmentModal]: ViewAppointmentModal,
  [ModalNamesEnum.addGarageDocuments]: AddGarageDocumentsModal,
  [ModalNamesEnum.editInsurance]: EditInsuranceModal,
  [ModalNamesEnum.loginMethodModal]: LoginMethodModal,
  [ModalNamesEnum.confirmWithRadioButtonsModal]: ConfirmWithRadioButtonsModal,
  [ModalNamesEnum.charityCampagneParticipate]: CharityCampagneParticipate,
  [ModalNamesEnum.hubFiltersModal]: HubFiltersModal,
  [ModalNamesEnum.hubSharePermissions]: HubSharePermissions,
  [ModalNamesEnum.healthInsuranceModal]: HealthInsuranceModal,
  [ModalNamesEnum.createReminderPopup]: CreateReminderPopup,
  [ModalNamesEnum.helpCenterModal]: HelpCenter,
  [ModalNamesEnum.feedbackModal]: Feedback,
  [ModalNamesEnum.sendUsAnEmailModal]: SendUsAnEmail,
  [ModalNamesEnum.petInsuranceModal]: PetInsuranceModal,
  [ModalNamesEnum.petVaccineModal]: PetVaccineModal,
  [ModalNamesEnum.sliderModal]: SliderModal,
  [ModalNamesEnum.personalShareModal]: PersonalShare,
  [ModalNamesEnum.deleteAccountUponRegistration]: DeleteAccountUponRegistration,
  [ModalNamesEnum.cloudUpdateName]: CloudUpdateName,
  [ModalNamesEnum.cloudDuplicateFile]: CloudDuplicateFile,
  [ModalNamesEnum.cloudMove]: CloudMove,
  [ModalNamesEnum.setupWidgets]: SetupWidgets,
  [ModalNamesEnum.spendingBreakdownDetails]: SpendingBreakdownDetailsModal,
  [ModalNamesEnum.inviteModal]: InviteModal,
  [ModalNamesEnum.assignedUsersListModal]: AssignedUsersListModal,
  [ModalNamesEnum.trialModal]: TrialModal,
  [ModalNamesEnum.scanHealthInsurance]: ScanHealthInsurance,
  [ModalNamesEnum.digitalPersonalCard]: DigitalPersonalCard,
  [ModalNamesEnum.digitalBusinessCard]: DigitalBusinessCard,
  [ModalNamesEnum.quickCreationHub]: QuickCreationHubModal,
  [ModalNamesEnum.feedbackSurveyModal]: FeedbackSurveyModal,
  [ModalNamesEnum.scanBusinessCard]: ScanBusinessCard,
};

export default modalsMap;
